/* eslint-disable react/no-array-index-key */
import { Row, Col, Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { HeadingWithSpaceLarge } from '../../../Components/Headings';
import FamilyDetailBox from '../../../Components/familyDetailBox/FamilyDetailBox';
import HealthCheckLayout from '../healthCheckLayout/HealthCheckLayout';
import img1 from '../../../assets/images/svg/no-image.svg';
import img2 from '../../../assets/images/png/family.png';
import addIcon from '../../../assets/images/png/add-icon.png';
import './familyMembers.css';

const memberData = [
  {
    image: img1,
    name: 'Taha Irshad',
    relation: 'Brother',
    phone: '+92 333 123 1234',
    email: 'tahairshad@weuno.com',
    height: '178',
    weight: '76',
    dob: '08 May 1987'
  },
  {
    image: img2,
    name: 'Rida Irshad',
    relation: 'Sister',
    phone: '+92 333 123 1234',
    email: 'ridawajod1234178@outlook.com',
    height: '178',
    weight: '76',
    dob: '08 May 1987'
  }
];

function FamilyMembers() {
  return (
    <HealthCheckLayout>
      <section className="familyMembers bgLinghtGray">
        <Container>
          <div className="addBox">
            <HeadingWithSpaceLarge text="ADD FAMILY MEMBERS" />
            <Link to="/addFamilyMember">
              <img src={addIcon} alt="addIcon" />
            </Link>
          </div>
          <Row>
            {memberData.map((member, index) => {
              const {
                image,
                name,
                relation,
                phone,
                email,
                height,
                weight,
                dob
              } = member;

              return (
                <Col md={6}>
                  <FamilyDetailBox
                    key={index}
                    memberImage={image}
                    name={name}
                    relation={relation}
                    phone={phone}
                    email={email}
                    height={height}
                    weight={weight}
                    dob={dob}
                  />
                </Col>
              );
            })}
          </Row>
        </Container>
      </section>
    </HealthCheckLayout>
  );
}

export default FamilyMembers;
